import { M_FLIGHTS_ERROR_CODE } from '../../../../../common/constants/errorCodes'
import { flyGaLogic } from '../../../../util/flyGaLogic'
import { clientErrorRedirect } from '../../../../helpers/clientErrorRedirect'
import {
  listingsIsLoading,
  listingsHasErrored,
  setOverfilteredBannerText,
  setOverfilteredStatus,
} from '../../actionCreators'

function _unkownErrorMessage(requestType) {
  return `Unknown error during ${requestType} airSearch request`
}

function _errorCode(error) {
  return error.code || error.errorCode
}

function _message(error, requestType) {
  return (
    _errorCode(error) ||
    error.message ||
    (error.messages && error.messages[0]) ||
    _unkownErrorMessage(requestType)
  )
}

const handleError = (dispatch, error = {}, requestType) => {
  flyGaLogic.fire.airSearchResponse(_message(error, requestType))

  const didOverFilter =
    requestType === 'FILTER' && error.desc === 'ZERO ITINS RETURNED-ES-3'
  const logError = {
    stack: error.stack || 'stack missing',
    message: error.message || 'message missing',
    messages:
      (error.messages && error.messages[0]) ||
      'if messages is an array and missing',
    code: error.code || error.errorCode || 'code is missing',
  }
  if (didOverFilter) {
    dispatch(listingsIsLoading(false))
    dispatch(setOverfilteredBannerText(false))
    dispatch(setOverfilteredStatus(true))
  } else if (_errorCode(error) === 'M0006') {
    dispatch(listingsIsLoading(false))
    dispatch(listingsHasErrored(true))
  } else if (error.messages && error.messages[0] === 'jwt expired') {
    window.location.assign(window.location.href)
  } else if (requestType === 'FILTER') {
    flyGaLogic.fire.airSearchResponse(
      _message(error, `no redirect to m-flights ${requestType}`)
    )
    flyGaLogic.fire.filterRedirect(logError, requestType)
    dispatch(listingsIsLoading(false))
    dispatch(setOverfilteredBannerText(false))
    dispatch(setOverfilteredStatus(true))
  } else if (requestType === 'INITIAL') {
    flyGaLogic.fire.airSearchResponse(
      _message(
        error,
        `initial search failed no redirect to m-flights ${requestType}`
      )
    )
    flyGaLogic.fire.filterRedirect(logError, requestType)
    dispatch(listingsIsLoading(false))
    dispatch(listingsHasErrored(true))
  } else {
    clientErrorRedirect(M_FLIGHTS_ERROR_CODE)
  }
}

export { handleError }
